import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allMonedasAction,
  deleteMonedasAction,
  setActivoMonedasAction,
} from '../MonedasAction';

const ListadoMonedas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const monedasStore = Redux.useSelector((state) => state.monedas);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      if (monedasStore.all && monedasStore.all.length === 0) {
        await allMonedasAction(dispatch, null);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = monedasStore.all.find((el) => el.id === id);
    await setActivoMonedasAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteMonedasAction(
      { dispatch, notify },
      monedasStore.activo.id,
      monedasStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.simbolo.name,
      label: CONST.simbolo.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.abrev.name,
      label: CONST.abrev.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  const data = monedasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setActivoMonedasAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  const isEntidades = monedasStore.activo?.totalEntidades > 0;

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={monedasStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={monedasStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {monedasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
          isText={!isEntidades}
          isConfirmBottom={!isEntidades}
        >
          {isEntidades ? (
            <Typography variant="body1">
              No puedes eliminar esta carrera porque tiene entidades relacionada
            </Typography>
          ) : (
            <Typography variant="h6">{monedasStore.activo.nombre}</Typography>
          )}
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoMonedas;
